// TODO: split in different files

interface Properties {
  name: string;
  description?: string;
  contenttype?: string;
  publisher?: string;
  sovereign?: string;
  dataOfferSource?: string;
  keywords?: string[];
  subCategory?: string;
  serviceType?: string;
  type?: string;
  language?: string;
  datasource?: string;
  method?: string;
  serviceOfferName?: string;
  baseUrl?: string;
}

/** A single static query parameter appended to the backend baseUrl on every transfer. */
export interface QueryParam {
  key: string;
  value: string;
  /**
   * Display-only: when true, the value is rendered as •••• in the app UI (overview,
   * edit list, summary). The value is still persisted in cleartext in the connector's
   * DataAddress — masking never reaches the wire. Persisted via the private property
   * {@link QUERY_PARAM_MASK_KEY} (list of masked keys), not the catalog-visible dataAddress.
   */
  masked?: boolean;
}

interface DataAddress {
  type: string;
  baseUrl: string;
  proxyPath: boolean;
  proxyQueryParams: boolean;
  proxyMethod: boolean;
  proxyBody: boolean;
  authMethod: AuthMethod;
  authHeaderName?: string;
  authHeaderValue?: string;
  /**
   * Static query parameters baked into the DataAddress (e.g. an `api_key`).
   * Serialized to the flat EDC wire property `queryParams` ("k=v&k2=v2") at the
   * adapter boundary. When set, `proxyQueryParams` must be false (see data-source-step).
   */
  queryParams?: QueryParam[];
}

export enum AuthMethod {
  NONE = 'NONE',
  API_KEY = 'API_KEY',
  OAUTH2 = 'OAUTH2',
  BASIC = 'BASIC'
}

export const SUPPORTED_AUTH_METHODS: ReadonlySet<AuthMethod> = new Set([
  AuthMethod.NONE,
  AuthMethod.API_KEY
]);

export enum ContentType {
  APPLICATION_JSON = 'application/json',
  APPLICATION_XML = 'application/xml',
  TEXT_CSV = 'text/csv',
  TEXT_PLAIN = 'text/plain',
  APPLICATION_PDF = 'application/pdf',
  APPLICATION_OCTET_STREAM = 'application/octet-stream'
}

export interface Asset {
  id?: string;
  properties: Properties;
  dataAddress: DataAddress;
  privateProperties?: Record<string, unknown>;
}

export interface AssetCreatedInfo {
  id: string;
  type: string;
  createdAt: Date;
}

export interface AssetUpdatedInfo {
  updated: boolean
}

export interface AssetDeletedInfo {
  deleted: boolean;
}

export enum Language {
  GERMAN = 'GERMAN',
  ENGLISH = 'ENGLISH'
}

export enum ServiceType {
  DATA_DELIVERY = 'DATA_DELIVERY',
  APP = 'APP'
}

export enum DataSource {
  REST_API = 'REST_API',
  AMAZON_S3 = 'AMAZON_S3',
  AZURE_BLOB = 'AZURE_BLOB',
  CUSTOM_DATASOURCE_CONFIG = 'CUSTOM_DATASOURCE_CONFIG',
  DATABASE = 'DATABASE'
}

export enum Method {
  PULL = 'PULL',
  PUSH = 'PUSH'
}

export interface PartnerMapping {
  customerKey: string;
  displayName: string;
}

export type PartnerMappings = Record<string, PartnerMapping>;

export const PARTNER_MAPPING_KEY = 'htxPartnerMappings';

/**
 * Private property holding the list of query-parameter keys whose values should be
 * masked in the app UI. Provider-private (not exposed in the catalog).
 */
export const QUERY_PARAM_MASK_KEY = 'htxMaskedQueryParams';

export const PARTNER_MAPPING_ASSET_TYPES = [
  'ORDER_CONFIRMATION', 'DELIVERY_NOTE', 'INVOICE'
] as const;
